export * from "./mock";
export * from "./profile";
export * from "./upload";
export * from "./social-links";

export const FORMAT_CREDIT_MAX_DECIMAL = 2; // 2 decimal places for credit

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MAX_CREDIT_PER_TX = 10_000; // ~ 10M vnd
export const MIN_CREDIT_PER_TX = 50; // ~ 50K vnd

export const SUPPORT_EMAIL = "daotaongheasean@gmail.com";

export const SUPPORT_HOTLINE = "+84 000 000 000"; // TODO: replace with real hotline
export const SUPPORT_WEBSITE = "humanexasia.com";

export enum ACTIVATION_FEE {
  CANDIDATE = 300_000,
  AGENT = 400_000
}

export const VAT_PERCENTAGE = 0.1;
